import { getEditableField, setEditableFieldValue } from '../../../store';
export var initializePushContent = function (_a) {
    var store = _a.store;
    var state = store.getState();
    var pushContent = getEditableField(state, 'pushBody').value;
    var titleContent = getEditableField(state, 'emailTitle').value;
    if (!pushContent && !!titleContent) {
        store.dispatch(setEditableFieldValue({ name: 'pushBody', value: titleContent }));
    }
};
